import {
add
  }from "../../commonFunctions"; 

const rp005 =  {
label:"Control Check", 
starting:true, 
url:"rp005", 
pageLabel:"Control Check", 
pageType:"history", 
form:[ {
inputType:"displaytext", 
isRequired:true, 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
placeHolder:"Parent Branch", 
label:"Parent Branch", 
name:"parentbranch", 
description:"Enter Parent Branch"
},  {
inputType:"autocomplete", 
default:"", 
elementProps: {
stayOpen:false, 
removeSelected:true, 
disabled:false, 
rtl:false
            }, 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
ajaxLoad:true, 
ajaxOptions: {
value:"code", 
label:"descn", 
query: {
dialect:"mysql", 
query:"getBranchName"
}
}, 
options:[
  {
    label:"Branch",
    value:"Branch"
  }
], 
//prepend:"Br.Name";
placeHolder:"Parent Branch ", 
name:"parentbranch", 
description:"Enter Parent Branch Code"
},  
{
  inputType: "showdata",
  data: "parentbranch",
  textcolor: "black",
  widths: {
    parent: "col-sm-2",
    children: "col-sm-12"
  }
},
{
inputType:"displaytext", 
isRequired:true, 
widths: {
parent:"col-sm-6", 
children:"col-sm-12"
}, 
placeHolder:"", 
label:"", 
name:"", 
description:""
},  {
inputType:"displaytext", 
isRequired:true, 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
placeHolder:"", 
label:"As on Date", 
name:"", 
description:""
},  {
inputType:"date", 
dateType:"ontype", 
isRequired:true, 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
displayFormat:"DD/MM/YYYY", 
outputFormat:"YYYYMMDD", 
placeHolder:"", 
label:"", 
name:"fromdate", 
description:""
},  {
inputType:"date", 
dateType:"ontype", 
isRequired:true, 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
displayFormat:"DD/MM/YYYY", 
outputFormat:"YYYYMMDD", 
placeHolder:"", 
label:"", 
name:"todate", 
description:""
},  {
inputType:"displaytext", 
isRequired:true, 
widths: {
parent:"col-sm-6", 
children:"col-sm-12"
}, 
placeHolder:"", 
label:"As on Date", 
name:"", 
description:""
},  {
inputType:"checkbox", 
isRequired:true, 
default:"false", 
widths: {
parent:"col-sm-2", 
children:"col-sm-12"
}, 
placeHolder:"", 
label:"Show Difference Only", 
name:"show", 
description:""
}, 
]
}
export default rp005; 